(() => {
  const palette={"3301":"#1d2223","3302":"#f9f8f3","3303":"#fbf8dc","3304":"#aba7a7","3305":"#efdcb2","3306":"#b58c5f","3308":"#d75122","3309":"#5f2a23","3310":"#c3090e","3311":"#6f1e24","3313":"#3a2a34","3317":"#555553","3330":"#5f5747","3342":"#9e5f3c","3343":"#6c483d","3344":"#426658","3345":"#404240","3346":"#97949b","3347":"#dcc48e","3348":"#313e6b"};
  if(customElements.get('jf-color-studio'))return;
  customElements.define('jf-color-studio',class extends HTMLElement {
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      this.owner=this.closest('jf-configurator');
      this.fields=this.closest('[data-chart-fields]');
      this.colorWrap=this.closest('.jf-custom-colors');
      this.text=JSON.parse(this.querySelector('[data-studio-text]').textContent);
      this.activeColorRole='main';
      this.active=false;
      this.scene=this.querySelector('[data-studio-scene]');
      this.galleryScene=this.scene.cloneNode(true);
      this.galleryScene.hidden=true;
      this.owner.querySelector('.jf-gallery').append(this.galleryScene);
      this.addEventListener('click',event=>this.clickControl(event),{signal:this.controller.signal});
      this.colorWrap.addEventListener('change',event=>{
        if(event.target.matches('[data-color-role]')){
          this.activeColorRole=event.target.dataset.colorRole;
          this.announce();
        }
      },{signal:this.controller.signal});
      this.mq=matchMedia('(max-width:749px)');
      this.mq.addEventListener('change',()=>this.sync(this.owner),{signal:this.controller.signal});
      if(this.owner.ready)this.sync(this.owner);
    }
    disconnectedCallback(){
      this.controller?.abort();this.controller=null;
      this.galleryScene?.remove();
      this.owner?.classList.remove('is-color-studio');
      this.colorWrap?.classList.remove('jf-studio-active');
    }
    clickControl(event){
      const tab=event.target.closest('[data-studio-tab]');
      if(tab){
        this.activeColorRole=tab.dataset.studioTab;
        if(this.activeColorRole==='trim'&&this.owner.querySelector('[data-color-same]').checked){
          this.owner.querySelector('[data-color-same]').checked=false;
          this.owner.updateSummary();
        }else this.sync(this.owner);
      }
      if(event.target.closest('[data-studio-same]')){
        const same=this.owner.querySelector('[data-color-same]');
        same.checked=!same.checked;
        this.activeColorRole=same.checked?'main':'trim';
        this.owner.updateSummary();this.announce();
      }
      if(event.target.closest('[data-studio-reset]')){
        this.owner.querySelectorAll('[data-color-role]').forEach(input=>input.checked=false);
        this.owner.querySelector('[data-color-same]').checked=false;
        this.activeColorRole='main';this.owner.updateSummary();this.announce();
      }
    }
    announce(){
      const main=this.owner.colorValue('main'),trim=this.owner.colorValue('trim');
      this.querySelector('[data-studio-announcement]').textContent=main?[this.text.main+' '+main,this.text.trim+' '+(trim||this.text.choose)].join('. '):this.text.selectMain;
    }
    sync(owner){
      if(!this.controller)return;
      if(!this.previewInitialized){
        this.previewInitialized=true;
        const preview=new URLSearchParams(location.hash.slice(1));
        if(preview.get('jf-studio')==='1')queueMicrotask(()=>{
          if(!this.isConnected||!this.scene.querySelector('jf-omont-viewer')?.dataset.source||!this.owner.leatherColors)return;
          this.owner.manualChartColor=true;
          for(const role of ['main','trim']){
            const code=preview.get(role);
            if(palette[code]){const input=this.owner.querySelector(`[data-color-role="${role}"][value="${code}"]`);if(input)input.checked=true;}
          }
          this.owner.render();
          const group=this.owner.querySelector('[data-color-group]');if(group)group.open=true;
          requestAnimationFrame(()=>{if(this.isConnected)this.scrollIntoView({block:'start',behavior:'instant'});});
        });
      }

      const viewerSource=this.scene.querySelector('jf-omont-viewer');
      const matchedSource=viewerSource?.dataset.sourceHandle===owner.model.handle;
      const active=matchedSource&&Boolean(viewerSource?.dataset.source)&&owner.chartColor&&owner.leatherColors;
      const entered=active&&!this.active;
      this.active=active;this.hidden=!active;this.galleryScene.hidden=!active;
      this.colorWrap.classList.toggle('jf-studio-active',active);
      owner.classList.toggle('is-color-studio',active);
      for(const scene of [this.scene,this.galleryScene]){
        const visible=scene===(this.mq.matches?this.scene:this.galleryScene);
        scene.querySelector('jf-omont-viewer').toggleAttribute('active',active&&visible);
      }
      if(!active)return;
      const main=owner.colorValue('main'),trim=owner.colorValue('trim');
      const facing=owner.choices.find(value=>/hand facing chaise/i.test(value))||'';
      for(const scene of [this.scene,this.galleryScene]){
        const viewer=scene.querySelector('jf-omont-viewer');
        viewer.setAttribute('main-color',palette[main]||'#b0b0ac');
        viewer.setAttribute('trim-color',palette[trim]||palette[main]||'#b0b0ac');
        viewer.setAttribute('facing',/^Left Hand Facing Chaise$/i.test(facing)?'left':'right');
      }
      const same=owner.querySelector('[data-color-same]').checked;
      for(const role of ['main','trim']){
        const value=role==='main'?main:trim;
        this.querySelector(`[data-studio-tab-code="${role}"]`).textContent=value||this.text.choose;
        this.querySelector(`[data-studio-tab="${role}"]`).setAttribute('aria-pressed',String(this.activeColorRole===role));
        const section=owner.querySelector(`[data-color-section="${role}"]`);
        section.hidden=this.activeColorRole!==role||(role==='trim'&&same);section.open=true;
        for(const scene of [this.scene,this.galleryScene]){
          scene.querySelector(`[data-studio-code="${role}"]`).textContent=value||'—';
          scene.querySelector(`[data-studio-chip="${role}"]`).style.backgroundColor=palette[value]||'#bdbdbd';
        }
      }
      const sameButton=this.querySelector('[data-studio-same]');sameButton.disabled=!main;sameButton.setAttribute('aria-pressed',String(same));
      const status=!main?this.text.selectMain:!trim?this.text.selectTrim:this.text.ready;
      for(const scene of [this.scene,this.galleryScene])scene.querySelector('[data-studio-status]').textContent=status;
      if(entered&&this.mq.matches)this.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }
  });
})();

